import { useState } from "react";
import { useForm } from "react-hook-form";

import {
  EmployeeEmailField,
  EmployeeFirstNameField,
  EmployeeHourlyRateField,
  EmployeeLastNameField,
  EmployeeLogoField,
  EmployeePhoneField,
} from "~/components/employees/employee-fields";
import { Form } from "~/components/ui/form";

import { Button } from "../ui/button";
import type { Step1Data } from "./common";

interface EmployeeFormStep1Props {
  onSubmit: (data: Step1Data) => void;
  data?: Step1Data;
}

export function EmployeeFormStep1({ onSubmit, data }: EmployeeFormStep1Props) {
  const [isUploading, setIsUploading] = useState(false);

  const form = useForm<Step1Data>({
    defaultValues: data ?? {
      imageUrl: undefined,
      phoneNumber: "",
      email: "",
      firstName: "",
      hourlyRate: undefined,
      lastName: "",
    },
  });

  return (
    <Form {...form}>
      <form
        className="space-y-5"
        onSubmit={form.handleSubmit((formData) => {
          onSubmit(formData);
        })}
      >
        <EmployeeLogoField
          control={form.control}
          name="imageUrl"
          setUploading={setIsUploading}
        />
        <div className="grid grid-cols-2 gap-4">
          <EmployeeFirstNameField control={form.control} name="firstName" />
          <EmployeeLastNameField control={form.control} name="lastName" />
        </div>
        <EmployeePhoneField control={form.control} name="phoneNumber" />
        <EmployeeEmailField control={form.control} name="email" required />
        <EmployeeHourlyRateField control={form.control} name="hourlyRate" />
        <Button
          className="w-full"
          disabled={isUploading}
          size="lg"
          type="submit"
        >
          {isUploading ? "Uploading image..." : "Next"}
        </Button>
      </form>
    </Form>
  );
}
